import { Injectable , Inject} from '@angular/core';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { APIService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class SpecilizationsService extends APIService{
  constructor(http: HttpClient,router :Router) {
    super(http)
    this.endPoint = "specilizations";
  }
  
  getAll(){
    return this.http.get(this.url,this.httpOptions)
  }
}
